export const $docContainer = $j('html, body, #form1, .maincontent, #contentBody');
export const scrn_lg = 1200;
export const scrn_md = 992;
export const scrn_sm = 768;
export const scrn_xs = 640;

export const CurrentPage = $j('section#content div.page').attr('id');
export const $header = $j('header');
export const $promoPageNavLinks = $j('#promoPageNavLinks');
export const mainNav = document.getElementById('mainNav');

export const promoProjectShortTitle = pId === 8505 ? 'VSPN' : pId === 680 ? 'VIN Students' : 'VIN';

export const isStandalone = 'standalone' in window.navigator && window.navigator.standalone;
export const ControlRenderer = `/apputil/VINControlRenderer.aspx?ControlName=`;
export const FetchAvailable = 'fetch' in window && 'assign' in Object;

export const managedOverflowClass = 'managed-overflow';
export const noOverFlowClass = 'no-overflow';
